import React from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import { Button, Grid, Stack, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { GENERAR_BALANCE } from "../../graphql/reporteador";
const BalanceGeneralReport = () => {
  const [generarExcel] = useLazyQuery(GENERAR_BALANCE);
  const formik = useFormik({
    initialValues: {
      tipo: "0",
      fechaInicio: "",
      fechaFin: "",
      PersonaId: "",
    },
    onSubmit: async (inputData) => {
      try {
        if (inputData.fechaFin < inputData.fechaInicio) {
          throw Error("La fecha de Fin no puede ser menor a la de inicio");
        }

        const l = await generarExcel({
          variables: {
            fechaInicio: inputData.fechaInicio,
            fechaFin: inputData.fechaFin,
          },
        });

        const { filename, mimetype, content } = l.data.generarExcel;

        const link = document.createElement("a");
        link.href = `data:${mimetype};base64,${content}`;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log(l);
      } catch (error) {
        console.log(error);
      }

      console.log(inputData);
    },
  });
  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container alignItems="flex-start" spacing={3}>
        <Grid item xs={12} md={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              onChange={(date) => formik.setFieldValue("fechaInicio", date)}
              value={formik.values.fechaInicio}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="fechaInicio"
                  fullWidth
                  variant="standard"
                  label="Fecha de Inicio"
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              onChange={(date) => formik.setFieldValue("fechaFin", date)}
              value={formik.values.fechaFin}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="fechaFin"
                  fullWidth
                  variant="standard"
                  label="Fecha de Fin"
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
        <Button type="submit">Generar Reporte </Button>
      </Stack>
    </form>
  );
};

export default BalanceGeneralReport;
